import { render, staticRenderFns } from "./PortalPayWorks.vue?vue&type=template&id=4ee1582a&"
import script from "./PortalPayWorks.vue?vue&type=script&lang=js&"
export * from "./PortalPayWorks.vue?vue&type=script&lang=js&"
import style0 from "./PortalPayWorks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports